import { redirect } from 'react-router-dom';

export const processLoginRedirect = (
  url: URL,
  hash = '',
  redirectQueryParam?: string,
) => {
  const redirectTo = redirectQueryParam ?? url.searchParams.get('redirect');
  if (redirectTo) {
    if (redirectTo.startsWith('app') || redirectTo.startsWith('/app')) {
      // @TODO this needs to be the basename
      return redirect(redirectTo.replace(/\/?app/, ''));
    }
    url.searchParams.set('hash', hash ?? '');
    url.searchParams.set('redirect', redirectTo);
    return redirect('/' + url.search);
  }
  return redirect('/');
};
